// extracted by mini-css-extract-plugin
module.exports = {"warning":"DuplikateIderVarsel_warning___wky7","lenkeInline":"DuplikateIderVarsel_lenkeInline__s64P_"};